import { requestApi } from '../util/network'

// 代理登录 团队
export const agent_list =
  (params, keyword, times) =>
    requestApi(
      '/agent/list',
      'POST',
      {
        'page': params.page,
        'limit': params.limit,
        'member_id': keyword,
        'create_time_start': times.create_time_start,
        'create_time_end': times.create_time_end,
      },
      'member'
    )
// 代理登录 团队 x详情
export const agent_gift_list =
  (params, member_id, times) =>
    requestApi(
      '/agent/gift_list',
      'POST',
      {
        'page': params.page,
        'limit': params.limit,
        'member_id': member_id,
        'create_time_start': times ? times.create_time_start : '',
        'create_time_end': times ? times.create_time_end : '',
      },
      'member'
    )
// 团队充值
export const agent_recharge_list =
  (params, member_id, times) =>
    requestApi(
      '/agent/recharge_list',
      'POST',
      {
        'page': params.page,
        'limit': params.limit,
        'member_id': member_id,
        'create_time_start': times ? times.create_time_start : '',
        'create_time_end': times ? times.create_time_end : '',
      },
      'member'
    )
// 团队提现
export const agent_withdraw_list =
  (params, member_id, times) =>
    requestApi(
      '/agent/withdraw_list',
      'POST',
      {
        'page': params.page,
        'limit': params.limit,
        'member_id': member_id,
        'create_time_start': times ? times.create_time_start : '',
        'create_time_end': times ? times.create_time_end : '',
      },
      'member'
    )
// 检测是否有推广权限
export const checkInviter =
  () =>
    requestApi(
      '/memberinviter/check',
      'POST',
      {
      },
      'member'
    )

// 获取推广海报
export const getInviterPoster =
  () =>
    requestApi(
      '/memberinviter/index',
      'POST',
      {

      },
      'member'
    )

// 获取推广会员
export const getInviterUser =
  (params) =>
    requestApi(
      '/memberinviter/user',
      'POST',
      {
        page: params.page,
        per_page: params.per_page,
        date: params.date,
        member_name: params.member_name
      },
      'member'
    )
// 获取 间推用户
export const getInviterUserChild =
  (params) =>
    requestApi(
      '/memberinviter/user_child',
      'POST',
      {
        page: params.page,
        per_page: params.per_page,
        date: params.date,
        member_name: params.member_name
      },
      'member'
    )
// 查询礼品卡列表
export const getSearchGift =
  (params) =>
    requestApi(
      '/Memberinviter/search_member_gift',
      'POST',
      {
        page: params.page,
        limit: params.limit,
        date: params.date,
        member_id: params.member_id
      },
      'member'
    )
// 获取 我的佣金
export const getCommissionInfo =
  (date) =>
    requestApi(
      '/commission/my_info',
      'POST',
      {
        date
      },
      'member'
    )
// 获取 我的佣金list 提现
export const getCommissionLogList =
  (params) =>
    requestApi(
      '/CommissionLog/list',
      'POST',
      {
        page: params.page,
        limit: params.limit,
        date: params.date
      },
      'member'
    )
// 获取 我的佣金list
export const getCommissionList =
  (params) =>
    requestApi(
      '/commission/list',
      'POST',
      {
        page: params.page,
        limit: params.limit,
        date: params.date,
        type: params.type,
      },
      'member'
    )
// 获取推广佣金
export const getInviterOrder =
  (params) =>
    requestApi(
      '/memberinviter/order',
      'POST',
      {
        page: params.page,
        per_page: params.per_page
      },
      'member'
    )
// 佣金划转
export const send_to_predeposit =
  (amount, form_token) =>
    requestApi(
      '/Commission/send_to_predeposit',
      'POST',
      {
        amount: amount,
        form_token:form_token
      },
      'member'
    )
export const createToken =
  () =>
  requestApi(
    '/token/create',
    'POST',
    {},
    'member'
  )